// ============================================================================
// ProgressoContrato · toast fixo no canto com barra de progresso, refletindo
// o ESTÁGIO REAL da geração (vindo da edge contract-status / execução n8n).
// ============================================================================

import styles from "./ProgressoContrato.module.css";

export interface ProgStatus {
  execId?: string;
  fase: string;
  etapa: string;
  pct: number;
  /** "demorou" = disparou mas não deu para confirmar a conclusão a tempo. */
  status: "aguardando" | "em_andamento" | "concluido" | "erro" | "demorou";
  detalhe?: string;
  /** Vêm preenchidos quando o contrato já existe no banco (conclusão real). */
  contrato_id?: string | null;
  cliente_id?: string | null;
  d4sign_document_uuid?: string | null;
}

export function ProgressoContrato({ prog, onClose }: { prog: ProgStatus | null; onClose: () => void }) {
  if (!prog) return null;
  const erro = prog.status === "erro" || prog.status === "demorou";
  const ok = prog.status === "concluido";
  const cls = erro ? styles.erro : ok ? styles.ok : styles.andamento;

  return (
    <div className={`${styles.toast} ${cls}`} role="status" aria-live="polite">
      <div className={styles.head}>
        <span className={styles.titulo}>
          {erro ? "Falha na geração" : ok ? "Contrato gerado" : "Gerando contrato"}
        </span>
        {(ok || erro) && (
          <button className={styles.fechar} onClick={onClose} aria-label="Fechar">×</button>
        )}
      </div>
      <div className={styles.etapa}>
        {!ok && !erro && <span className={styles.spinner} aria-hidden="true" />}
        <span>{prog.etapa}{!ok && !erro ? "…" : ""}</span>
      </div>
      {prog.detalhe && erro && <div className={styles.detalhe}>{prog.detalhe}</div>}
      <div className={styles.barraFundo}>
        <div className={styles.barra} style={{ width: `${Math.max(5, Math.min(100, prog.pct))}%` }} />
      </div>
      {ok && <a href="/" className={styles.linkBoard}>Ver no board →</a>}
    </div>
  );
}
